import { useEffect, useRef } from "react";

export const useAutoTokenRefresh = ({
  accessToken,
  refreshToken,
  tokenExpiry,
  onRefresh,
}: {
  accessToken: string;
  refreshToken: string;
  tokenExpiry: number | undefined; // in seconds (Unix time)
  onRefresh: () => Promise<void>;
}) => {
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (!accessToken || !tokenExpiry) return;

    const expirationTime = tokenExpiry * 1000; // convert to ms
    const now = Date.now();
    const refreshDelay = expirationTime - now - 60_000; // refresh 1 min before

    if (refreshDelay <= 0) {
      onRefresh(); // Token is expiring or expired
      return;
    }

    timeoutRef.current = window.setTimeout(() => {
      onRefresh();
    }, refreshDelay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [accessToken, refreshToken, tokenExpiry, onRefresh]);
};
